import { formatDate } from '../stringUtils';
export const getFormattedSeasonDatesForPark = (seasons) => {
    if (!seasons.length) {
        return ['Not available'];
    }
    const currentYear = new Date().getFullYear();
    return seasons.reduce((prev, { startDate, endDate }) => {
        const openDate = formatDate(startDate);
        const closeDate = formatDate(endDate);
        if (new Date(endDate).getFullYear() >= currentYear) {
            const season = `${openDate} - ${closeDate}`;
            return [...prev, season];
        }
        return prev;
    }, []);
};
